// extracted by mini-css-extract-plugin
export var topSection = "style-module--topSection--3it2X";